module.exports = __webpack_public_path__ + "assets/img/02-402f7fcf.jpg";